import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useDisabledState } from 'common/disabled-context';
import { isFieldPathTouched } from 'common/components/farm/locations/helpers';

export const useActiveFormState = (fieldName) => {
  const { touched, dirty, setTouched } = useFormikContext();
  const { setActiveForm, activeForm } = useDisabledState();

  const disableForm = Boolean(activeForm && activeForm !== fieldName);

  useEffect(() => {
    // Check if this specific form is being edited
    const isBeingEdited = isFieldPathTouched(touched, fieldName);
    if (isBeingEdited && dirty) {
      setActiveForm(fieldName);
    }

    if (!dirty) {
      setActiveForm(null);
      setTouched({});
    }
  }, [dirty, fieldName, setActiveForm]);

  return {
    setActiveForm,
    activeForm,
    disableForm
  };
};
